import { Injectable } from '@angular/core';
import { environment } from 'environment/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiUrlService {
  private apiUrl = environment.authApiBaseUrl + '/api';

  public getUsersUrl(): string {
    return `${this.apiUrl}/users`;
  }

  public getUserInfoUrl(): string {
    return `${this.getUsersUrl()}/me`;
  }
}
